import { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { Flex } from 'antd';
import { Text } from '../Ant';
import { ChevronDown } from '../icons';
import { PickerTrigger } from '../../assets/styles/components/featureBox';

interface ISetupFieldProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'value' | 'type' | 'children'
> {
  ref?: Ref<HTMLButtonElement>;
  label: string;
  icon: ReactNode;
  value: string;
  isOpen: boolean;
}

/** A labelled field of the workspace setup that shows its current value and opens a picker to change it. */
const SetupField = ({
  ref,
  label,
  icon,
  value,
  isOpen,
  className,
  ...buttonProps
}: ISetupFieldProps) => (
  <PickerTrigger
    ref={ref}
    type="button"
    aria-expanded={isOpen}
    // Top-aligned so fields sharing a row keep their labels level when one value wraps.
    // The Dropdown passes its own trigger classes in, so they are added to ours rather than replacing them.
    className={['d-flex items-start w-full p-10 ta-left cursor-pointer', className]
      .filter(Boolean)
      .join(' ')}
    {...buttonProps}
  >
    <Flex component="span" align="center" gap={10} className="w-full">
      <Flex component="span" vertical gap={5} className="flex-grow min-w-0">
        <Text $fontsize="12px" $weight={500} $lineheight="20px" $color="description">
          {label}
        </Text>
        <Flex component="span" align="center" gap={10}>
          {icon}
          <Text
            $fontsize="13px"
            $weight={600}
            $lineheight="18px"
            $color="title"
            className="min-w-0"
          >
            {value}
          </Text>
        </Flex>
      </Flex>
      <ChevronDown className="picker-chevron fz-18 flex-shrink-0 text-clr-general-description" />
    </Flex>
  </PickerTrigger>
);

export default SetupField;
